import React from 'react';
import { TransitionGroup, CSSTransition as ReactTransition } from 'react-transition-group';
import useLiveData from 'hooks/useLiveData';
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from 'utils/theme';

import blogBG1 from 'images/backgrounds/blogBG1.svg';
import blogBG2 from 'images/backgrounds/blogBG2.svg';
import blogBG3 from 'images/backgrounds/blogBG3.svg';
import blogBG4 from 'images/backgrounds/blogBG4.svg';
import blogBG1Mobile from 'images/backgrounds/blogBG1-mobile.svg';
import blogBG2Mobile from 'images/backgrounds/blogBG2-mobile.svg';
import blogBG3Mobile from 'images/backgrounds/blogBG3-mobile.svg';
import blogBG4Mobile from 'images/backgrounds/blogBG4-mobile.svg';

import randomBG from 'generated/blogBackground.json';

// if backgrounds are added or removed, update the randomIndex variable in the onPreBootstrap within root project's gatsby-node.js

const blogBGs = [
	{desktop: blogBG1, mobile: blogBG1Mobile},
	{desktop: blogBG2, mobile: blogBG2Mobile},
	{desktop: blogBG3, mobile: blogBG3Mobile},
	{desktop: blogBG4, mobile: blogBG4Mobile},
];

const Transition = props => {
	const media = {
		xs: useMediaQuery(theme.breakpoints.down('sm')),
	};
	const { children, location, data } = props;
	const timeout = 300;

	const isBlog = props?.pageContext?._type === 'BlogPost';

	const randomPosition = isBlog ? randomBG.randomIndex : null;

	const getTransitionStyles = {
		entering: {
			opacity: 0,
		},
		entered: {
			transition: `opacity ${timeout}ms ease-in-out`,
			opacity: 1,
		},
		exiting: {
			transition: `opacity ${timeout}ms ease-in-out`,
			opacity: 0,
		},
	};

	const { response } = useLiveData({
		type: 'ContentPage',
		method: 'all',
		staticData: data,
	});
	const page = response?.data.filter(item => item.uri === props.location.pathname).shift();
	const isSvg = page?.additionalFields.pageBackground && page?.additionalFields.pageBackground.includes('.svg');

	const mainContentStyle = {
		...(page?.additionalFields?.pageBackground ? {
			backgroundSize: 'contain',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'top center',
			backgroundImage: `url('${process.env.CDN_DOMAIN||''}${page.additionalFields.pageBackground}${isSvg ? '' : '?format=webp&quality=100&max-w=1920'}')`,
		} : {}),
		...((isBlog) ? {
			backgroundSize: 'contain',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: `top ${media.xs ? '': '200px'} center`,
			backgroundImage: `url('${process.env.CDN_DOMAIN||''}${blogBGs[randomPosition][media.xs ? 'mobile' : 'desktop']}')`,
		} : {})
	}

	return(
		<TransitionGroup>
		<ReactTransition
			key={location.pathname}
			timeout={{ enter: timeout, exit: timeout }}
			onExit={(node) => {
				node.style.width = '100vw'; // Ensure full width
				node.style.height = '100vh'; // Ensure full height
			}}
			onEntered={(node) => {
				node.style.width = '';
				node.style.height = '';
				window.scrollTo(0, 0); // Restore scroll on new page
			}}
		>
			{(status) => (
				<div style={{ ...getTransitionStyles[status], ...mainContentStyle }} aria-live="assertive">
					{children}
				</div>
			)}
		</ReactTransition>
		</TransitionGroup >
	);
};

export default Transition;
